import React, { useState } from 'react';
import { Modal, Icon } from 'antd-mobile'
//@ts-ignore
import QRCode from 'qrcode-react';
import moment from 'moment'
import '../../Mine/component/index.css';
import { common } from '../../../common/common';

const MineModal = (props: any) => {
  const { visible, onClose, data, refresh } = props;
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      transparent={true}
      style={{ width: '80%' }}
    >
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', paddingTop: 65 }}>
        <div style={{ position: 'absolute', right: 0, top: 0 }} onClick={onClose} >
          <Icon type='cross-circle' />
        </div>
        <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', fontSize: 18, fontWeight: 'bold', color: 'black' }}>
          他人支付
        </div>
        <div>
          <div style={{ width: 158, height: 158, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', border: '1px solid #e3e3e3' }}>
            <QRCode value={data.code_url} size={136} />
          </div>
          <div className='mine-modal-code' style={{ color: common.color.primary }} onClick={refresh}>{`刷新付款码`}</div>
          <div className='mine-modal-tip'>*请截图让他人进行付款，如遇付款码失效请点击刷新付款码</div>
        </div>
      </div>
    </Modal>
  )
}

export default MineModal;